import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { TwoColumnLayoutService } from 'src/app/common-components/column-layouts/two-column-list-layout/services/selected-id.service';
import { Register } from 'src/app/common-components/register/models/register';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { getSchedulePrivileges } from 'src/app/privileges/privileges.selector';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { SchedulesFilterOption } from '../models/schedule-filter-option';
import { SchedulePrivileges } from '../models/schedule-privileges';
import { ScheduleOrderingOptions, ScheduleRegisterOptions } from '../models/schedule-register-options';
import { ScheduleRegisterListItem } from '../models/schedule-register-results.model';
import * as ScheduleRegisterActions from '../state/schedule-register.actions';
import {
   createSchedule,
   scheduleRegisterAdapterActions,
   scheduleRegisterInitialFilter,
} from '../state/schedule-register.actions';
import * as scheduleRegisterReducer from '../state/schedule-register.reducer';
@Component({
    selector: 'ndt-schedule-register',
    templateUrl: './schedule-register.component.html',
    standalone: false
})
export class ScheduleRegisterComponent
   extends Register<ScheduleRegisterListItem, ScheduleRegisterOptions, ScheduleOrderingOptions>
   implements OnInit
{
   columns: string[] = ['name', 'description'];

   entityName = 'Schedule';

   schedulePrivileges$: Observable<SchedulePrivileges>;

   filters: SchedulesFilterOption[];

   constructor(public store: Store, private twoColumnLayoutService: TwoColumnLayoutService) {
      super(store, scheduleRegisterReducer.selectors, scheduleRegisterAdapterActions);
      this.schedulePrivileges$ = store.pipe(select(getSchedulePrivileges));

      store
         .select(getSelectedAccountId)
         .pipe(
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            }),
            map((accountId: number) => {
               const filters: SchedulesFilterOption[] = [
                  {
                     field: 'AccountId',
                     operation: FilterOperations.EqualTo,
                     type: 'numeric',
                     value: accountId,
                  },
               ];
               return filters;
            })
         )
         .subscribe((filters) => {
            this.filters = filters;
            // set selected ID to null when account changes
            this.twoColumnLayoutService.setSelectedId(null);
         });
   }

   ngOnInit() {
      this.store.dispatch(scheduleRegisterInitialFilter({ filters: this.filters }));
      this.store.dispatch(this.actions.pageEnter());
      // Subscribe to changesToNotify$ to get notified of added or deleted schedules
      this.twoColumnLayoutService.changesToNotify$.pipe(takeUntil(this.destroyed$)).subscribe(() => {
         // Refresh list when notified of added or deleted schedules
         this.store.dispatch(ScheduleRegisterActions.refreshList());
      });
   }

   onCreate(): void {
      this.store.dispatch(createSchedule());
   }

   handleSelectedId(id: number) {
      this.twoColumnLayoutService.setSelectedId(id);
   }

   onScheduleSaveAs(schedule: ScheduleRegisterListItem) {
      this.store.dispatch(ScheduleRegisterActions.saveScheduleAs({ schedule }));
   }
}
